import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectFilteredData } from '../../../ReportsHarvestInspectionsTable/selectors';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const makeSelectFieldAverage = () =>
    createDeepEqualSelector([selectFilteredData], filteredDataState => {
        if (!filteredDataState) return 0;
        const data = filteredDataState.filter(value => value.averageSize);
        if (!data.length) return 0;
        const total = data.reduce((acc, cur) => acc + cur.averageSize, 0);
        const average = total / data.length;
        return Math.ceil(average * 100) / 100;
    });

export { makeSelectFieldAverage };
